import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import type { ModuleWithData, ModuleWithOutData} from '@zoomit/web-kit';
import { mapModules } from '@zoomit/web-kit';

type Args = {
  id: string | null;
  modulesWithOutData: ModuleWithOutData[];
  fetchModuleCallback(): Promise<AxiosResponse<ModuleWithData[]>>;
};

export const useModuleDataFetching = (args: Args) => {
  const { modulesWithOutData, fetchModuleCallback, id } = args;

  const handleGetModules = async () => {
    const res = await fetchModuleCallback();
    return mapModules(res.data);
  };

  const moduleQuery = useQuery(['modules', id], handleGetModules, {
    initialData: () => mapModules(modulesWithOutData),
  });

  return {
    ...moduleQuery,
    data: moduleQuery.data,
  };
};
